import { render, staticRenderFns } from "./OnboardingLinkModal.vue?vue&type=template&id=2a290387&scoped=true&"
import script from "./OnboardingLinkModal.vue?vue&type=script&lang=js&"
export * from "./OnboardingLinkModal.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingLinkModal.vue?vue&type=style&index=0&id=2a290387&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a290387",
  null
  
)

export default component.exports